import { toast } from "react-toastify";
import fetchRedux from "../../../../api/fetch_redux";
import { ToastErro } from "../../../../utils/utilitarios";

export const CASHBACK_GET_DATA = "CASHBACK_GET_DATA";
export const CASHBACK_CLEAR = "CASHBACK_CLEAR";
export const CASHBACK_SET_MODAL = "CASHBACK_SET_MODAL";
export const CASHBACK_CLOSE_MODAL = "CASHBACK_CLOSE_MODAL";
export const CASHBACK_UPDATE_CLIENT = "CASHBACK_UPDATE_CLIENT";
export const CASHBACK_ADD = "CASHBACK_ADD";
export const CASHBACK_DELETE = "CASHBACK_DELETE";

const ROUTE = ["/cashback_api"];

export const cashbackGetData = (data, setWait) => (dispatch) => {
  const urlParams = new URLSearchParams(data);
  fetchRedux(
    `${ROUTE[0]}?${urlParams.toString()}`,
    "GET",
    null,
    (result) => {
      dispatch({
        type: CASHBACK_GET_DATA,
        data: result,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const cashbackClear = () => ({
  type: CASHBACK_CLEAR,
});

export const cashbackSetModal = (data) => ({
  type: CASHBACK_SET_MODAL,
  data,
});

export const cashbackCloseModal = () => ({
  type: CASHBACK_CLOSE_MODAL,
});

export const cashbackEditClient = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[0],
    "PATCH",
    data,
    (result) => {
      toast.dark(result.sucesso, {
        type: "success",
      });
      dispatch({
        type: CASHBACK_UPDATE_CLIENT,
        data: result.data,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const cashbackNew = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[0],
    "POST",
    data,
    (result) => {
      toast.dark(result.sucesso, {
        type: "success",
      });
      dispatch({
        type: CASHBACK_ADD,
        data: result.data,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const deleteCashback = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[0],
    "DELETE",
    data,
    (result) => {
      toast.dark(result.sucesso, {
        type: "success",
      });
      dispatch({
        type: CASHBACK_DELETE,
        data: data.id,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};
